import React from 'react';
import {
  Box,
  Modal,
  Card,
  CardContent,
  Button,
  Portal,
  Typography,
  TextField,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const DAYS = [
  { label: 'Pn', value: 'monday' },
  { label: 'Wt', value: 'tuesday' },
  { label: 'Śr', value: 'wednesday' },
  { label: 'Cz', value: 'thursday' },
  { label: 'Pt', value: 'friday' },
  { label: 'Sb', value: 'saturday' },
  { label: 'Nd', value: 'sunday' }
];

export default function BlockModal({ open, blockFunction, handleClose, showDays = false }) {
  const [reason, setReason] = React.useState('');
  const [daysToBlock, setDaysToBlock] = React.useState('all');

  const handleChange = e => setReason(e.target.value);

  const handleDayToggle = (event, newDays) => {
    if (newDays.length === 0) {
      setDaysToBlock([]);
    } else {
      setDaysToBlock(newDays);
    }
  };

  const handleBlock = () => {
    blockFunction(false, reason, daysToBlock);
    handleClose();
  };

  return (
    <Portal>
      <Modal open={open} onClose={handleClose} id="block-modal">
        <Card sx={{ ...style, width: '500px' }}>
          <CardContent>
            <Typography variant="body1" textAlign="center">
              Podaj przyczynę blokady
            </Typography>

            <Box height={20} />
            <TextField
              label="przyczyna blokady..."
              fullWidth
              size="small"
              value={reason}
              onChange={handleChange}
            />

            {showDays && (
              <>
                <Box height={20} />
                <Typography variant="body2">Zablokuj w dni:</Typography>
                <ToggleButtonGroup
                  value={daysToBlock === 'all' ? DAYS.map(d => d.value) : daysToBlock}
                  onChange={handleDayToggle}
                  size="small"
                  fullWidth
                  color="primary"
                >
                  {DAYS.map(day => (
                    <ToggleButton key={day.value} value={day.value}>
                      {day.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
                <Box height={10} />
                <Button
                  size="small"
                  onClick={() => setDaysToBlock(
                    daysToBlock === 'all' || daysToBlock.length === DAYS.length
                      ? []
                      : DAYS.map(d => d.value)
                  )
                  }
                >
                  {daysToBlock.length === DAYS.length ? 'Odznacz wszystko' : 'Zaznacz wszystkie'}
                </Button>
              </>
            )}

            <Box height={20} />
            <Button variant="contained" onClick={handleBlock}>
              Zablokuj
            </Button>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
}
